import { ELocale } from '~~/types/enums'

export const useLang = (_lang: ELocale) => {
  const runtimeConfig = useRuntimeConfig()
  const i18nStore = useI18nStore()
  const { locale, t: $t } = useI18n()

  let lang = runtimeConfig.public.lang
  i18nStore.setLang(_lang)

  if (_lang.toUpperCase() == ELocale.en) {
    lang = 'en'
    locale.value = 'en'
  } else if (_lang.toUpperCase() == ELocale.cn || _lang.toUpperCase() == ELocale.zh) {
    lang = 'cn'
    locale.value = 'zh'
  }
  return { lang, $t }
}
